import React from 'react'
import {Bar} from 'react-chartjs-2'
import type {StatusBucket} from './_requests'

interface Props {
  title: string
  data: StatusBucket[]
  completedLabel: string
  cancelledLabel: string
}

export const StatusBarChart: React.FC<Props> = ({
  title,
  data,
  completedLabel,
  cancelledLabel,
}) => {
  const chartData = {
    labels: data.map((d) => d.label),
    datasets: [
      {
        label: completedLabel,
        data: data.map((d) => d.completed),
        backgroundColor: '#a3a242',
        borderRadius: 4,
        barPercentage: 0.6,
        categoryPercentage: 0.7,
      },
      {
        label: cancelledLabel,
        data: data.map((d) => d.cancelledOrAbandoned),
        backgroundColor: '#d7383c',
        borderRadius: 4,
        barPercentage: 0.6,
        categoryPercentage: 0.7,
      },
    ],
  }

  const options: any = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {display: false},
      tooltip: {
        mode: 'index' as const,
        intersect: false,
      },
    },
    scales: {
      x: {
        grid: {display: false},
        ticks: {font: {family: 'Manrope', size: 11}, color: '#565d6d'},
      },
      y: {
        grid: {color: '#f3f4f6', drawBorder: false},
        ticks: {font: {family: 'Manrope', size: 11}, color: '#565d6d'},
        beginAtZero: true,
      },
    },
  }

  return (
    <div className='cp-chart-card'>
      <h3 className='cp-chart-card__title' style={{marginBottom: 24}}>
        {title}
      </h3>
      <div className='cp-legend'>
        <div className='cp-legend__item'>
          <span className='cp-legend__dot cp-legend__dot--olive' />
          <span>{completedLabel}</span>
        </div>
        <div className='cp-legend__item'>
          <span className='cp-legend__dot cp-legend__dot--red' />
          <span>{cancelledLabel}</span>
        </div>
      </div>
      <div style={{height: 300}}>
        <Bar data={chartData} options={options} />
      </div>
    </div>
  )
}
